export const regexDict = {
  // 邮箱校验 xxx@domain.com
  emialCheck: {
    pattern:
      /^[a-zA-Z0-9_.!#$%&'*+/=?^`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
    message: '请输入正确邮箱',
  },

  // 用于校验纳税识别号, /斜杠忽略校验
  taxNoRegex: {
    pattern: /^[a-zA-Z\d]+$|^\/$/,
    message: '只能包含字母和数字',
  },
  mobileSymbol: {
    pattern:
      /^[\d～·！＠＃￥％……＆＊（）－——＝＋、｜、’“：；》《。，!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+$/,
    message: '只允许输入数字和符号',
  },
  // 客户订单号
  orderNoRegex: {
    pattern:
      /^[A-Za-z0-9!@#$%^&*()-]([A-Za-z0-9!@#$%^&*()-\s]*[A-Za-z0-9!@#$%^&*()-])?$/,
    message: '只允许输入字母，数字，半角符号，首尾不能输入空格',
  },
  // 报备金额
  filingPrice: {
    pattern: /^(0\.\d{1,2}|[1-9]\d*(\.\d{1,2})?)$/,
    message: '仅支持大于零的两位小数',
  },
  税收分类名称: {
    pattern:
      /^[\u4e00-\u9fa5～·！＠＃￥％……＆＊（）－——＝＋、｜、’“：；》《。，!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{1,40}$/,
    message: '请输入1-40位的中文/字符',
  },
} as const

/**
 * 校验文件名是否为excel后缀
 * @param filename
 */
export function isExcel(filename: string) {
  return /[^\s]+\.(xls|xlsx)$/i.test(filename)
}

export function isZip(filename: string) {
  return /[^\s]+\.(zip)$/i.test(filename)
}

export function extractInvoiceNumber(str: string) {
  // 匹配"被红冲蓝字数电发票号码："或"被红冲蓝字数电发票号码:"后的数字，兼容冒号与数字之间的空格
  const regex = /被红冲蓝字数电发票号码[：:]\s*(\d+)/
  const match = str?.match(regex)

  if (str && match && match[1]) {
    return match[1]
  } else {
    return null
  }
}
export const regexDict = {
  // 邮箱校验 xxx@domain.com
  emialCheck: {
    pattern:
      /^[a-zA-Z0-9_.!#$%&'*+/=?^`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
    message: '请输入正确邮箱',
  },

  // 用于校验纳税识别号, /斜杠忽略校验
  taxNoRegex: {
    pattern: /^[a-zA-Z\d]+$|^\/$/,
    message: '只能包含字母和数字',
  },
  mobileSymbol: {
    pattern:
      /^[\d～·！＠＃￥％……＆＊（）－——＝＋、｜、’“：；》《。，!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+$/,
    message: '只允许输入数字和符号',
  },
  // 客户订单号
  orderNoRegex: {
    pattern:
      /^[A-Za-z0-9!@#$%^&*()-]([A-Za-z0-9!@#$%^&*()-\s]*[A-Za-z0-9!@#$%^&*()-])?$/,
    message: '只允许输入字母，数字，半角符号，首尾不能输入空格',
  },
  // 报备金额
  filingPrice: {
    pattern: /^(0\.\d{1,2}|[1-9]\d*(\.\d{1,2})?)$/,
    message: '仅支持大于零的两位小数',
  },
  税收分类名称: {
    pattern:
      /^[\u4e00-\u9fa5～·！＠＃￥％……＆＊（）－——＝＋、｜、’“：；》《。，!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{1,40}$/,
    message: '请输入1-40位的中文/字符',
  },
} as const

/**
 * 校验文件名是否为excel后缀
 * @param filename
 */
export function isExcel(filename: string) {
  return /[^\s]+\.(xls|xlsx)$/i.test(filename)
}

export function isZip(filename: string) {
  return /[^\s]+\.(zip)$/i.test(filename)
}

export function extractInvoiceNumber(str: string) {
  // 匹配"被红冲蓝字数电发票号码："或"被红冲蓝字数电发票号码:"后的数字，兼容冒号与数字之间的空格
  const regex = /被红冲蓝字数电发票号码[：:]\s*(\d+)/
  const match = str?.match(regex)

  if (str && match && match[1]) {
    return match[1]
  } else {
    return null
  }
}
